import React, { useEffect, useState } from "react";
import "./Request.scss";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import TableContainer from "@mui/material/TableContainer";
import { useDispatch, useSelector } from "react-redux";
import { DispatchType } from "../../interfaces/redux.interface";
import TeacherSpecificRequest from "./teacher/TeacherSpecificRequest";
import GeneralRequest from "./teacher/GeneralRequest";
import { startLoading, stopLoading } from "../../redux/slices/WindowSlice";
import { getTeachers } from "../../redux/slices/TeacherSlice";
import RequestHistory from "./teacher/RequestHistory";
import WithdrawnRequest from "./teacher/WithdrawnRequest";
import { RootState } from "../../redux/store";

const Request = () => {
  const dispatch: DispatchType = useDispatch();
  const [teacherSubTab, setTeacherSubTab] = useState("1");

  const handleTeacherSubTabChange = (_event, newValue) => {
    setTeacherSubTab(newValue);
  };

  const { signedAdmin } = useSelector((state: RootState) => state.admin);

  useEffect(() => {
    if (!signedAdmin?.id) return;
    dispatch(startLoading());
    dispatch(getTeachers()).finally(() => {
      dispatch(stopLoading());
    });
    // eslint-disable-next-line
  }, [signedAdmin?.id]);

  return (
    <div className="request">
      <div className="title">Tuition Requests</div>
      <div className="container">
        <TabContext value={teacherSubTab}>
          <Box
            className="mb-3"
            sx={{ borderBottom: 1, borderColor: "divider" }}
          >
            <TabList
              onChange={handleTeacherSubTabChange}
              aria-label="Teacher subtabs"
              sx={{
                "& .MuiTab-root": {
                  color: "var(--color-light-gray)",
                  "&:hover": {
                    color: "var(--color-primary)!important",
                    backgroundColor: "rgba(0, 0, 0, 0.1)",
                    borderRadius: "8px 8px 0 0",
                  },
                },
                "& .Mui-selected": {
                  color: "var(--color-primary)!important",
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                  fontWeight: "bold",
                  borderRadius: "8px 8px 0 0",
                },
                "& .MuiTabs-indicator": {
                  backgroundColor: "var(--color-primary)",
                },
              }}
            >
              <Tab label="Specific" value="1" />
              <Tab label="General" value="2" />
              <Tab label="History" value="3" />
              <Tab label="Withdrawn" value="4" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <TableContainer>
              {teacherSubTab === "1" && <TeacherSpecificRequest />}
            </TableContainer>
          </TabPanel>
          <TabPanel value="2">
            <TableContainer>
              {teacherSubTab === "2" && <GeneralRequest />}
            </TableContainer>
          </TabPanel>
          <TabPanel value="3">
            <TableContainer>
              {teacherSubTab === "3" && <RequestHistory />}
            </TableContainer>
          </TabPanel>
          <TabPanel value="4">
            <TableContainer>
              {teacherSubTab === "4" && <WithdrawnRequest />}
            </TableContainer>
          </TabPanel>
        </TabContext>
      </div>
    </div>
  );
};

export default Request;
